import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'

import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureHouseholdInviteModule } from '../lib/shared-feature-household-invite.module'
import { HouseholdInviteExampleComponent } from './household-invite-docs/examples/household-invite-example.component'
import { HouseholdGuardianInviteDocsComponent } from './household-invite-docs/household-invite-docs.component'


@NgModule({
  declarations: [HouseholdGuardianInviteDocsComponent, HouseholdInviteExampleComponent],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureHouseholdInviteModule
  ],
  exports: [HouseholdGuardianInviteDocsComponent],
  providers: []
})
export class SharedFeatureHouseholdInviteDocsModule {}
